'use client';

import { Box, Button, Modal, Typography } from '@mui/material';
import { Check, Close } from '@mui/icons-material';
import Link from 'next/link';
import { CookieBannerProps } from '@/actions/cookie-banner/getCookieBannerData';

const style = {
  padding: 2,
  margin: 2,
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: 'whitesmoke',
  bottom: 0,
  maxHeight: 'fit-content',
  width: '100%',
};

interface props {
  open: boolean;
  handleAccepted: () => void;
  handleDeclined: () => void;
  cookieBannerData: CookieBannerProps;
}

const CookieBannerModal = ({ open, handleAccepted, handleDeclined, cookieBannerData }: props) => (
  // Rendered in place and without the fade-in, so the server HTML already paints it
  <Modal
    open={open}
    onClose={handleDeclined}
    disableScrollLock
    disablePortal
    slotProps={{ backdrop: { slotProps: { transition: { appear: false } } } }}
  >
    <Box style={style} sx={{ position: 'absolute', textAlign: 'center' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          ml: 2,
        }}
      >
        <Typography variant='body1'>
          {cookieBannerData.title}
          {!cookieBannerData.cta.hidden && (
            <Link
              href={cookieBannerData.cta.href}
              target={cookieBannerData.cta.newTab ? '_blank' : '_self'}
              style={{ textDecoration: 'underline' }}
            >
              {cookieBannerData.cta.text}
            </Link>
          )}
        </Typography>
      </Box>
      <Box sx={{ padding: 0, maxWidth: 'fit-content', mt: { xs: 1, lg: 'auto' } }}>
        <Button onClick={handleDeclined} color='error' variant='outlined' startIcon={<Close />}>
          {cookieBannerData.declineButton}
        </Button>
        <Button
          onClick={handleAccepted}
          color='secondary'
          variant='contained'
          sx={{ margin: 1 }}
          startIcon={<Check />}
        >
          {cookieBannerData.acceptButton}
        </Button>
      </Box>
    </Box>
  </Modal>
);

export default CookieBannerModal;
